<template>
  <div class="space-y-4">
    <div>
      <p class="text-base font-extrabold text-green-500">Step One</p>
      <p class="text-xl font-extrabold text-brand-black my-2">Place Embed Code</p>
      <p class="text-base font-semibold text-brand-brown">
        Copy the code below. Paste it before the closing
        <pre class="text-green-500 font-mono inline-block mx-1"><code>{{ closeBody }}</code></pre>
        tag in your app code.
      </p>
      <div class="mt-4">
        <pre v-highlightjs="clientSideScript"><code class="javascript"></code></pre>
      </div>
      <div class="flex justify-end flex-grow-0 mt-6">
        <a href="https://docs.churnkey.co/installing-churnkey" target="_blank" class="el-button mx-2 el-button--primary is-plain">Get Help</a>
        <el-button type="primary" class="mx-2" @click="copyEmbedSnippet(clientSideScript)">Copy Code</el-button>
      </div>
    </div>

    <div>
      <p class="text-base font-extrabold text-green-500">Step Two</p>
      <p class="text-xl font-extrabold text-brand-black my-2">Launch Churnkey</p>
      <p class="text-base font-semibold text-brand-brown">
        It's easy to connect Churnkey and launch it from any button on your website. Simply replace BUTTON_ID with
        your desired element's id.
      </p>
      <div class="mt-4">
        <pre v-highlightjs="clientSideSampleCode"><code class="javascript"></code></pre>
      </div>
      <div class="flex justify-end flex-grow-0 mt-6">
        <a href="https://docs.churnkey.co/installing-churnkey" target="_blank" class="el-button mx-2 el-button--primary is-plain">Get Help</a>
        <el-button type="primary" class="mx-2" @click="copyEmbedSnippet(clientSideSampleCode)">Copy Code</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { singleScriptInstall, invokeChurnkeyFlowLite } from '@/components/Cancellation/EmbedCode/snippets';

export default {
  name: 'EmbedInstructions',
  data() {
    return {
      closeBody: '</body>',
    };
  },
  computed: {
    ...mapGetters(['appId']),
    clientSideScript() {
      return singleScriptInstall.replace('APP_ID', this.appId || 'APP_ID')
    },
    clientSideSampleCode() {
      return invokeChurnkeyFlowLite.replace('APP_ID', this.appId || 'APP_ID')
    },
    org() {
      return this.$store.state.org;
    },
  },
  methods: {
    async copyEmbedSnippet(snippet) {
      try {
        await this.$copyText(snippet);
        this.$message({
          message: 'Copied to clipboard',
          type: 'success',
        });
      } catch (e) {
        this.$message({
          message: 'Could not copy to clipboard',
          type: 'error',
        });
      }
    },
  },
};
</script>
